export { Performance } from './Performance'

export interface PerformanceInterface {

  /**
   * 对象数
   */
  objects: number

  /**
   * 顶点数
   */
  vertices: number

  /**
   * 三角面数
   */
  triangles: number

  /**
   * 渲染时间
   */
  renderTime: number

  /**
   * drawCall 绘制调用数
   */
  drawCall: number

  /**
   * 内存
   */
  memory: number

  /**
   * fps
   */
  fps: number
}
